import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Question, QuestionsService } from '../../../services/questions.service';

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    standalone: false,
})
export class QuestionComponent implements OnInit {
    @Input() question: Question;
    @Output() saved = new EventEmitter<any>();
    form: FormGroup;
    isSaving = false;

    constructor(
        private fb: FormBuilder,
        private answerService: QuestionsService
    ) {
        this.form = this.fb.group({
            choice_id: [null, Validators.required],
        });
    }

    ngOnInit() {}

    save() {
        if (!this.form.valid || !this.question) return;
        this.isSaving = true;
        const answer = {
            question_id: this.question.id,
            choice_id: this.form.value.choice_id,
            is_correct:
                this.question.choices.find(choice => choice.id === this.form.value.choice_id)?.is_correct || false,
            toolbox_id: this.question.toolbox_id,
        };
        this.answerService.registerAnswer(answer).subscribe({
            next: answer => {
                this.isSaving = false;
                this.saved.emit(answer.data);
            },
            error: () => {
                this.isSaving = false;
            },
        });
    }
}
